module.exports = __webpack_public_path__ + "static/media/VISA.b42ee6b7.png";